"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexUnusedRule = void 0;
exports.isIndexUnused = isIndexUnused;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const date_1 = require("../../helpers/date");
const duration_1 = require("../../helpers/duration");
const rule_1 = require("../rule");
const ruleId = 'index-unused';
const ruleName = 'unused index';
const ruleDescription = 'indexes with the same number of scans during the threshold period or the last scan older than the threshold';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.ConstraintId.array().optional(),
    minDays: zod_1.z.number()
}).strict().describe('IndexUnusedConf');
exports.indexUnusedRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.medium, minDays: 10 },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity && r.extra?.index?.name ? { ...r.entity, constraint: r.extra.index.name } : undefined).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.constraintRefFromId) || []);
        const historyEntitiesById = history.map(h => ({ report: h.report, date: h.date, entities: (0, utils_1.indexBy)(h.database.entities || [], databaseUtils_1.entityToId) }));
        return (db.entities || [])
            .flatMap(e => (e.indexes || []).map(i => ({ entity: e, index: i })))
            .filter(({ entity, index: { name } }) => !(name && ignores.some(i => (0, databaseUtils_1.constraintRefSame)(i, { ...(0, databaseUtils_1.entityToRef)(entity), constraint: name }))))
            .map(e => {
            const previous = historyEntitiesById.map(h => {
                const entity = h.entities[(0, databaseUtils_1.entityToId)(e.entity)];
                const index = entity ? entity.indexes?.find(i => i.name === e.index.name) : undefined;
                return entity && index ? { report: h.report, date: h.date, value: { entity, index } } : undefined;
            }).filter(utils_1.isNotUndefined);
            return isIndexUnused(now, e, previous, conf.minDays);
        })
            .filter(utils_1.isNotUndefined)
            .map(r => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Index ${r.current.index.name}(${r.current.index.attrs.map(databaseUtils_1.attributePathToId).join(', ')}) on ${(0, databaseUtils_1.entityToId)(r.current.entity)} is unused since ${(0, date_1.showDate)(r.date)} (check all instances to be sure!).`,
            entity: (0, databaseUtils_1.entityToRef)(r.current.entity),
            extra: (0, utils_1.removeUndefined)({
                index: r.current.index,
                previousReport: r.report,
                previousDate: new Date(r.date).toISOString(),
                previous: r.previous?.index?.stats,
                current: r.current.index.stats,
            })
        }));
    }
};
function isIndexUnused(now, current, history, minDays) {
    const { scans, scansLast } = current.index.stats || {};
    if (scans && scans > 0) {
        const sameAsCurrent = history.filter(h => now - h.date > minDays * duration_1.oneDay).map(h => h.value.index.stats?.scans === scans ? { date: h.date, current, previous: h.value, report: h.report } : undefined).filter(utils_1.isNotUndefined);
        const res = (0, utils_1.minBy)(sameAsCurrent, d => d.date);
        if (res)
            return res;
    }
    if (scansLast) {
        const lastScan = new Date(scansLast).getTime();
        if (now - lastScan > minDays * duration_1.oneDay) {
            return { date: lastScan, current };
        }
    }
    return undefined;
}
//# sourceMappingURL=indexUnused.js.map